import Bottle from 'bottlejs';
import keyManagerContainerFactory from './KeyManagerContainer';
import keyManagerViewFactory from './KeyManagerView';
import keyManagerDataFactory from './KeyManagerData';

export default () => {
  const keyManagerBottle = new Bottle();
  keyManagerContainerFactory(keyManagerBottle);
  keyManagerViewFactory(keyManagerBottle);
  keyManagerDataFactory(keyManagerBottle);
  return keyManagerBottle;
};
